const CONTEXT_PATH = "/contributionadmin";
export const ROUTES = {
  DASHBOARD: "/",
  CHANGE_PASSWORD: `${CONTEXT_PATH}/changePassword`,
  FORGET_PASSWORD: `${CONTEXT_PATH}/forgetPassword`,
  CONTRIBUTION_CYCLE: `${CONTEXT_PATH}/masters/contributionCycles`,
  CHAPTER_LEVEL_CONTRIBUTION_CYCLE: `${CONTEXT_PATH}/masters/chapterLevelContributionCycles`,
  BANK_DEPOSIT_DETAILS: `${CONTEXT_PATH}/cashSettlements/bankDepositDetails`,
  PAYABLE_CITY: `${CONTEXT_PATH}/masters/payableCities`,
  BANK_DETAILS: `${CONTEXT_PATH}/masters/bankDetails`,
  BRANCH_DETAILS: `${CONTEXT_PATH}/masters/branchDetails`,
  MESSAGE_TICKER: `${CONTEXT_PATH}/masters/messageTicker`,
  RECEIPT_TYPES: `${CONTEXT_PATH}/masters/receiptTypes`,
  DRAWN_BANK_DETAILS: `${CONTEXT_PATH}/masters/drawnBankDetails`,
  OTP_AUTHENTICATION_PAGE: `${CONTEXT_PATH}/otpAuthentication`,
  LOGIN_PAGE: `${CONTEXT_PATH}/login`,
  CANCELLED_RECEIPT_REPORT: `${CONTEXT_PATH}/reports/cancelledReceiptReport`,
  TOTAL_RECEIPT_REPORT: `${CONTEXT_PATH}/reports/totalReceiptReport`,
  TOTAL_CANCELLED_RECEIPT_REPORT: `${CONTEXT_PATH}/reports/totalCancelledReceiptReport`,
  TOTAL_COLLECTION_REPORT: `${CONTEXT_PATH}/reports/totalCollectionReport`,
  CONTRIBUTION_COMPARISON_REPORT: `${CONTEXT_PATH}/reports/contributionComparisonReport`,
  CHEQUES_DETAILS_REPORT: `${CONTEXT_PATH}/reports/chequesDetailsReport`,
  TOTAL_COLLECTION_CHAPTER_REPORT: `${CONTEXT_PATH}/reports/totalCollectionChapterReport`,
  MEMBER_SEARCH: `${CONTEXT_PATH}/members/memberSearch`,
  MEMBER_CONTRIBUTION_VIEW: `${CONTEXT_PATH}/members/contributionView`,
  MEMBER_VIEW: `${CONTEXT_PATH}/members/memberView`,
  MEMBER_CONTRIBUTION_VIEW_UPDATE: `${CONTEXT_PATH}/members/contributionViewUpdate`,
  MEMBER_CONTRIBUTION_DETAILS: `${CONTEXT_PATH}/members/contributionDetails`,
  MEMBER_CONTRIBUTION_UPDATE: `${CONTEXT_PATH}/members/contributionUpdate`,
  PENDING_ONLINE_CONTRIBUTION: `${CONTEXT_PATH}/onlineContribution/pendingOnlineContribution`,
  CAPTURE_ONLINE_CONTRIBUTION: `${CONTEXT_PATH}/onlineContribution/captureOnlineContribution`,
  DOWNLOAD_REPORTS: `${CONTEXT_PATH}/reports/downloadReports`,
  REPORT_CAPTURE_ONLINE_CONTRIBUTION: `${CONTEXT_PATH}/onlineContribution/reportCaptureOnlineContribution`,
  SEARCH_ONLINE_CONTRIBUTION_PRINT_FORM: `${CONTEXT_PATH}/onlineContribution/searchOnlineContributionPrintForm`,
  CASH_REPORT: `${CONTEXT_PATH}/reports/cashReport`,
  FORM_10_BE_SEARCH: `${CONTEXT_PATH}/reports/forms10BESearch`,
  TAX_UTILITY_REPORT: `${CONTEXT_PATH}/reports/taxUtility`,
};
